import { AUTH_STATUS, LOGOUT } from "../types";
const initialState = {
  isLogin: false,
  userData: {},
};
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_STATUS:
      return {
        ...state,
        isLogin: window.sessionStorage.getItem("jwt"),
        userData: JSON.parse(window.sessionStorage.getItem("user")),
      };
    case LOGOUT:
      return {
        ...state,
        isLogin: false,
        userData: {},
      };
    default:
      return state;
  }
};

export default authReducer;
